import React, {useState} from 'react';
import {useLocation} from 'react-router-dom';
import {
    AssignmentOutlined,
    CloudUploadOutlined,
    DescriptionOutlined,
    EditOutlined,
    HomeOutlined,
    InsertChartOutlined,
    SettingsOutlined
} from '@material-ui/icons';
import AppMenu from '../shared/menu/AppMenu.js';
import MenuButtonSimpleLink from '../shared/menu/MenuButtonSimpleLink.js';
import MenuButtonMultipleLinks from '../shared/menu/react-router-dom_6/MenuButtonMultipleLinks.js';
import useInitialPath from '../../hooks/useInitialPath.js';
import useCheckModule from '../../hooks/useCheckModule.js';
import {MODULOS_CADASTROS} from '../../constants/index.js';
import DialogRelatorioCadastroBolsistas from './dialogs/relatorio/DialogRelatorioCadastroBolsistas.jsx';

/* Segmento da rota logo depois de /administrativo → botão do menu destacado. */
const MENU_POR_SEGMENTO = {
    acompanhamento: 'Acompanhamento',
    inscricoes: 'Inscrições',
    cadastros: 'Cadastros',
    'carga-saf': 'Carga SAF',
    recursos: 'Recursos',
    relatorios: 'Relatórios'
};

/*
 * Mesma árvore e mesmos módulos (ADGERAL, sistema SYSBENEF) do menu do
 * administrativo PrimeFaces: botão sem permissão fica oculto; item de
 * submenu sem permissão fica desabilitado.
 */
export default function Menu() {
    const {pathname} = useLocation();
    const initialPath = useInitialPath();
    const checkModule = useCheckModule();
    const [dialogCadastroBolsistasAberto, setDialogCadastroBolsistasAberto] = useState(false);

    const base = `/${initialPath}`;
    const selected = MENU_POR_SEGMENTO[pathname.split('/')[2]] || 'Início';
    const temAlgumModulo = (...modulos) => modulos.some(modulo => checkModule(modulo));

    return (
        <>
        <AppMenu>
            <MenuButtonSimpleLink
                label='Início'
                to={base}
                selected={selected === 'Início'}
                icon={<HomeOutlined/>}/>
            <MenuButtonSimpleLink
                label='Acompanhamento'
                to={`${base}/acompanhamento`}
                selected={selected === 'Acompanhamento'}
                icon={<InsertChartOutlined/>}/>
            {checkModule('INSCRICAO') && (
                <MenuButtonSimpleLink
                    label='Inscrições'
                    to={`${base}/inscricoes`}
                    selected={selected === 'Inscrições'}
                    icon={<AssignmentOutlined/>}/>
            )}
            {temAlgumModulo(...MODULOS_CADASTROS) && (
                <MenuButtonMultipleLinks
                    label='Cadastros'
                    selected={selected === 'Cadastros'}
                    icon={<EditOutlined/>}
                    options={[
                        {
                            label: 'Básico',
                            options: [
                                {label: 'Programa', to: `${base}/cadastros/programas`, disabled: !checkModule('PROGRAMA')},
                                {label: 'Documento', to: `${base}/cadastros/documentos`},
                                {label: 'Tipo de Habitação', to: `${base}/cadastros/tipos-habitacao`, disabled: !checkModule('HABITACAO')},
                                {label: 'Tipo de Moradia', to: `${base}/cadastros/tipos-moradia`, disabled: !checkModule('MORADIA')}
                            ]
                        },
                        {label: 'Processo de Seleção', to: `${base}/cadastros/processos-selecao`, disabled: !checkModule('PROCSEL')},
                        {label: 'Coordenadores Central de Bolsas', to: `${base}/cadastros/coordenadores`},
                        {
                            label: 'Atendimento',
                            options: [
                                {label: 'Atendente', to: `${base}/cadastros/atendentes`, disabled: !checkModule('CFATENDENT')},
                                {label: 'Responsável', to: `${base}/cadastros/responsaveis`, disabled: !checkModule('CFRESPONS')}
                            ]
                        }
                    ]}/>
            )}
            {checkModule('CARGASAF') && (
                <MenuButtonMultipleLinks
                    label='Carga SAF'
                    selected={selected === 'Carga SAF'}
                    icon={<CloudUploadOutlined/>}
                    options={[
                        {label: 'Pbest e outros', to: `${base}/carga-saf/pbest`, disabled: !checkModule('PBEST')},
                        {label: 'Prouni/Fies', to: `${base}/carga-saf/prouni-fies`, disabled: !checkModule('PROUNI')},
                        {label: 'Pesquisar Cargas', to: `${base}/carga-saf/pesquisa`, disabled: !checkModule('PESQCARGAS')}
                    ]}/>
            )}
            {checkModule('RCENVEMAIL') && (
                <MenuButtonMultipleLinks
                    label='Recursos'
                    selected={selected === 'Recursos'}
                    icon={<SettingsOutlined/>}
                    options={[
                        {label: 'Enviar e-mails', to: `${base}/recursos/envio-emails`, disabled: !checkModule('RCENVEMAIL')}
                    ]}/>
            )}
            {checkModule('RELMENU') && (
                <MenuButtonMultipleLinks
                    label='Relatórios'
                    selected={selected === 'Relatórios'}
                    icon={<DescriptionOutlined/>}
                    options={[
                        {label: 'Termos de Concessão de Bolsas', to: `${base}/relatorios/termos-concessao`, disabled: !checkModule('RELCONCBOL')},
                        {label: 'Cadastro dos Bolsistas', onClick: () => setDialogCadastroBolsistasAberto(true)}
                    ]}/>
            )}
        </AppMenu>
        {/* Montado só aberto: o loading global do diálogo não interfere no carregamento inicial. */}
        {dialogCadastroBolsistasAberto && (
            <DialogRelatorioCadastroBolsistas open onClose={() => setDialogCadastroBolsistasAberto(false)}/>
        )}
        </>
    );
}
